import { render } from "./ThankYouOrder.vue?vue&type=template&id=78902327&scoped=true"
import script from "./ThankYouOrder.vue?vue&type=script&lang=js"
export * from "./ThankYouOrder.vue?vue&type=script&lang=js"

import "./ThankYouOrder.vue?vue&type=style&index=0&id=78902327&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78902327"]])

export default __exports__